module.exports = __webpack_public_path__ + "a56462324fa321e1bc881007102ff55d.png";